// extracted by mini-css-extract-plugin
export default {"root":"MiniFASelectorComplication_root__oD-OG","selector":"MiniFASelectorComplication_selector__m7Jza"};